import {AxiosResponse} from "axios"
import {PagedData} from "@/services/models/shared/PagedData";
import BimsHttpService from "@/services/BimsHttpService";
import {
  AccountsFilterOptions,
  Account
} from "@/services/models/Account";

class AccountsService {
  /**
   * @description Returns a paged list of accounts
   */
  getAccounts(filter: AccountsFilterOptions
  ): Promise<PagedData<Account>> {
      return BimsHttpService.get(`/accounts`, {
          params: filter
      }).then((response: AxiosResponse<PagedData<Account>>) => {
          return response.data as PagedData<Account>;
      });
  }
}

export default new AccountsService();
